import React from "react";
import { observer } from "mobx-react-lite";
import { TranslationContext } from "./Translation";
import pl from "../../shared/messages/pl";
import cs from "../messages/cs";
import sk from "../messages/sk";
import en from "../messages/en";
import { constants } from "../constants";

const TranslationProvider: React.FC<React.PropsWithChildren> = observer(({ children }) => {
    const mapLanguageVersionToTranslationFile = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const languageCode = urlParams.get(constants.languageCodeQueryParameterName);

        switch (languageCode) {
            case constants.languageCodes.english:
                return en;
            case constants.languageCodes.czech:
                return cs;
            case constants.languageCodes.slovakian:
                return sk;
            default:
                return pl;
        }
    };

    return (
        <TranslationContext.Provider value={mapLanguageVersionToTranslationFile()}>
            {children}
        </TranslationContext.Provider>
    );
});

export default TranslationProvider;
